/**
 * 组件注入
 * @param {*} Vue 
 */
export const MdvUI = (Vue) => {
  console.log(Vue)
}
